import React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import {defaultVariables} from "../../../config";
import { getStore } from "trim-redux";
import { Copyright } from "lucide-react";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function CopyrightFooter({  }) {
    const { t } = useTranslation();

    return (
        <Typography
            variant="body2"
            align="center"
            style={{textAlign:"center",maxWidth:"100%"}}
        >
            <Copyright className="lucide-smaller"/> {moment().format('YYYY')} {t('copyright')}{' '}
            <Link color="primary" href={defaultVariables.website}>
                {t('companyName')}
            </Link>{' '}
        </Typography>
    );
}
